import firebase from 'firebase';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Lesson from '../views/Lesson.vue';
import Auth from '../views/Auth.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/login',
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/login',
    name: 'Login',
    components: { default: Auth },
    props: { default: true },
  },
  {
    path: '/signup',
    name: 'SignUp',
    components: { default: Auth },
    props: { default: true },
  },
  {
    path: '/reset',
    name: 'ForgotPassword',
    components: { default: Auth },
    props: { default: true },
  },
  {
    path: '/lesson/:lesson',
    name: 'Lesson',
    components: { default: Lesson },
    props: { default: true },
  },
  {
    path: '/lesson/:lesson/:viewer',
    name: 'LessonPublic',
    components: { default: Lesson },
    props: { default: true },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const { currentUser } = firebase.auth();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('login');
  else if (!requiresAuth && currentUser && !to.name.startsWith('Lesson')) next('home');
  /* Note: LessonPublic does not redirect, so the teacher can test the software on him/herself */
  else next();
});


export default router;
